import {
    Box, useMediaQuery, useTheme,
} from '@mui/material';
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import { forwardRef } from 'react';
import { SecondaryTooltip } from '../foundation/Tooltip';

export type SimilarityGaugeProps = {
    similarity: number;
    size?: 'medium' | 'large' | 'small';
    tooltipText?: string | JSX.Element;
};

const ForwardGauge = forwardRef<HTMLDivElement, any>(({
    value, innerRadius, sx, text, ...rest
}, ref) => <Box ref={ref} {...rest}><Gauge value={value} innerRadius={innerRadius} sx={sx} text={text} /></Box>);

const SimilarityGauge = (props: SimilarityGaugeProps) => {
    const { similarity } = props;
    const percentage = Math.round(similarity * 100);
    const theme = useTheme();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    let height = 170;
    let fontSize = 35;

    if (props.size === 'medium') {
        height = 80;
        fontSize = 18;
    } else if (props.size === 'large') {
        height = 250;
        fontSize = 50;
    }

    if (isSmallScreen || props.size === 'small') {
        height *= 0.4;
        fontSize *= 0.4;
    }

    const width = height;

    return (
        <Box width={width} >
            <SecondaryTooltip title={props.tooltipText || 'אחוז התאמה למשרה מבוסס AI'} placement="bottom" arrow>
                <ForwardGauge
                    value={percentage || 0}
                    innerRadius="91%"
                    sx={{
                        height,
                        [`& .${gaugeClasses.valueArc}`]: {
                        // eslint-disable-next-line no-nested-ternary
                            fill: similarity > 0.7 ? theme.palette.primary : similarity > 0.5 ? '#FFC400' : '#b91f0b',
                        },
                        [`& .${gaugeClasses.valueText}`]: {
                            fontSize,
                            // transform: 'translate(0px, -25px)',
                            direction: 'rtl',
                        },
                    }}
                    text={({ value, valueMax: _valueMax }) => `${value}%`}
                />
            </SecondaryTooltip>
        </Box>
    );
};

export default SimilarityGauge;
